import { fromJS } from 'immutable'
import {
  EMPLOYEE_LEVELS_GET_REQUEST,
  EMPLOYEE_LEVELS_GET_SUCCESS,
  EMPLOYEE_LEVELS_GET_FAILURE,
  EMPLOYEE_LEVELS_GET_RESET,
} from './../../constants'

const init = fromJS({
  isFetching: false,
  isAuthenticated: localStorage.getItem('access_token') !== null,
  redirect: false,
})

export default (state = init, action) => {
  switch (action.type) {
    case EMPLOYEE_LEVELS_GET_REQUEST:
      return state
        .set('isFetching', true)
    case EMPLOYEE_LEVELS_GET_SUCCESS:
      return state
        .set('employeeLevels', fromJS(action.payload.employee))
        .set('isFetching', false)
    case EMPLOYEE_LEVELS_GET_FAILURE:
      if (action.payload.status === 401) {
        return state
          .set('redirect', true)
      }
      return state
        .set('isFetching', false)
    case EMPLOYEE_LEVELS_GET_RESET:
      return state
        .delete('employeeLevels')
        .set('isFetching', false)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/employee-levels/employee-levels-get-reducer.js